// src/features/clients/hooks/useClients.js
import { useState, useEffect, useCallback } from 'react';
import { fetchClients, createClient, updateClient } from '../../../api';

const useClients = () => {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState('');

  const loadClients = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const res = await fetchClients();
      setClients(res.data);
    } catch {
      setError('فشل في جلب قائمة العملاء.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadClients();
  }, [loadClients]);

  const addClient = useCallback(async (payload) => {
    const res = await createClient(payload);
    await loadClients();
    return res.data;
  }, [loadClients]);

  const editClient = useCallback(async (id, payload) => {
    const res = await updateClient(id, payload);
    await loadClients();
    return res.data;
  }, [loadClients]);

  return { clients, loading, error, loadClients, addClient, editClient };
};

export default useClients;